import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from "@/components/shadcn/dialog.tsx"
import {
  Drawer,
  DrawerContent,
  DrawerTrigger,
} from "@/components/shadcn/drawer.tsx"
import DrawerAnimalContent from "@/features/farm/components/drawer-animals/drawer-animal-content.tsx"
import { useMediaQuery } from "@/hooks/use-media-query.ts"

interface TriggerComponentProps {
  currentValue: string[] | string
  onClick: () => void
}

interface CombinedComponentProps {
  currentValue: string[] | string
  onSaveClick: (animalIDs: string[]) => void
  selectionType?: "single" | "multiple"
  TriggerComponent: React.FC<TriggerComponentProps>
}

const DrawerAnimals: React.FC<CombinedComponentProps> = ({
  onSaveClick,
  currentValue,
  selectionType = "multiple",
  TriggerComponent,
}) => {
  const { t } = useTranslation()
  const isDesktop = useMediaQuery("(min-width: 768px)")
  const [open, setOpen] = useState(false)

  const content = (
    <DrawerAnimalContent
      selectionType={selectionType}
      currentValue={currentValue}
      onSaveClick={(ids) => {
        onSaveClick(ids)
        if (selectionType === "single") setOpen(false)
      }}
      placeholder={t("searchAnimal")}
    />
  )

  if (isDesktop) {
    return (
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogTrigger asChild>
          <TriggerComponent currentValue={currentValue} onClick={() => {}} />
        </DialogTrigger>
        <DialogContent
          withBack={false}
          className="h-[85vh] max-w-2xl overflow-hidden p-0"
        >
          {content}
        </DialogContent>
      </Dialog>
    )
  }

  return (
    <Drawer open={open} onOpenChange={setOpen} shouldScaleBackground>
      <DrawerTrigger asChild>
        <TriggerComponent currentValue={currentValue} onClick={() => {}} />
      </DrawerTrigger>
      <DrawerContent className="h-[85%]">{content}</DrawerContent>
    </Drawer>
  )
}

export default DrawerAnimals
